var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { PatientAccountDeletionRequestReasonType } from "healthex-common/patient.dtos";
import { FormModel } from "./FormModel";
import { NamedRoutes } from "./NamedRoutes";
import { validators } from "../Logic/Validators";
import { getObservableT } from "../Infra/i18next";
import { computed, observable } from "mobx";
const t = getObservableT("patients");
export const maxDeleteMyAccountReasonLength = 500;
export class PatientDeleteMyAccountViewModel {
    constructor(container) {
        this.formModel = new FormModel({
            reasonType: null,
            reasonMessage: "",
        }, []);
        this.submitting = false;
        this.container = container;
        this.patientService = container.patientService;
        this.appUIManager = container.appUIManager;
    }
    get hasReasonTypeError() {
        return this.formModel.hasError("reasonType") && this.formModel.input.reasonType === null;
    }
    get hasReasonMessageError() {
        return (this.formModel.hasError("reasonMessage") &&
            this.reasonMessageVisible &&
            (this.formModel.input.reasonMessage.length === 0 || this.formModel.input.reasonMessage.length > maxDeleteMyAccountReasonLength));
    }
    get reasonMessageVisible() {
        return this.formModel.input.reasonType === PatientAccountDeletionRequestReasonType.OTHER;
    }
    validateInput() {
        const { notBlank, notNull } = validators;
        const f = this.formModel;
        f.clearErrors();
        f.validateField("reasonType", notNull, t("Please enter a reason to continue"));
        if (this.reasonMessageVisible) {
            f.validateField("reasonMessage", notBlank, t("Please enter a reason to continue"));
            if (this.formModel.input.reasonMessage.length > maxDeleteMyAccountReasonLength) {
                this.formModel.addError("reasonMessage", t("Please keep your reason under {{ maxCharacterCount }} characters", {
                    maxCharacterCount: maxDeleteMyAccountReasonLength,
                }));
            }
        }
        return !f.hasErrors();
    }
    async deleteMyAccount() {
        if (!this.validateInput())
            return;
        if (!this.container.authManager.id)
            return;
        if (!this.formModel.input.reasonType)
            return;
        const deletedReasonMessage = this.reasonMessageVisible ? this.formModel.input.reasonMessage : null;
        this.submitting = true;
        try {
            await this.patientService.deleteAccount(this.container.authManager.id, {
                deletedReasonType: this.formModel.input.reasonType,
                deletedReasonMessage,
            });
            await this.appUIManager.logout();
        }
        catch (error) {
            console.error("Error deleting account:", error);
        }
        finally {
            this.submitting = false;
        }
    }
    async cancel() {
        const routing = this.container.routingUIManager;
        if (routing.previousRoute) {
            routing.navigateBack();
        }
        else {
            routing.navigateTo(NamedRoutes.PATIENT_RECORDS);
        }
    }
}
__decorate([
    observable
], PatientDeleteMyAccountViewModel.prototype, "submitting", void 0);
__decorate([
    computed
], PatientDeleteMyAccountViewModel.prototype, "hasReasonTypeError", null);
__decorate([
    computed
], PatientDeleteMyAccountViewModel.prototype, "hasReasonMessageError", null);
__decorate([
    computed
], PatientDeleteMyAccountViewModel.prototype, "reasonMessageVisible", null);
